import { render, staticRenderFns } from "./UsuarioDataGestion.vue?vue&type=template&id=330afb76&"
import script from "./UsuarioDataGestion.vue?vue&type=script&lang=js&"
export * from "./UsuarioDataGestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports